import { render, staticRenderFns } from "./orderListMobile.vue?vue&type=template&id=5dfc85c6&scoped=true"
import script from "./orderListMobile.vue?vue&type=script&lang=js"
export * from "./orderListMobile.vue?vue&type=script&lang=js"
import style0 from "./orderListMobile.vue?vue&type=style&index=0&id=5dfc85c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc85c6",
  null
  
)

export default component.exports